import { get, patch, post } from './request';
import {
  CreateEstateUnitPayload,
  EstateUnit,
  EstateUnitStatusEnum,
  GetEstateUnitsFilters,
  UpdateEstateUnitPayload
} from '../types/EstateUnit';

const buildQuery = (filters?: GetEstateUnitsFilters): string => {
  if (!filters) {
    return '';
  }

  const params: string[] = [];

  if (filters.estateId) {
    params.push(`estateId=${filters.estateId}`);
  }

  if (filters.status) {
    params.push(`status=${filters.status}`);
  }

  return params.length > 0 ? `?${params.join('&')}` : '';
};

export const getEstateUnits = async (
  filters?: GetEstateUnitsFilters
): Promise<EstateUnit[]> => {
  return get(`/estate-units${buildQuery(filters)}`);
};

export const getEstateUnit = async (id: string): Promise<EstateUnit> => {
  return get(`/estate-units/${id}`);
};

export const createEstateUnit = async (
  payload: CreateEstateUnitPayload
): Promise<EstateUnit> => {
  return post('/estate-units', payload);
};

export const updateEstateUnit = async (
  id: string,
  payload: UpdateEstateUnitPayload
): Promise<EstateUnit> => {
  return patch(`/estate-units/${id}`, payload);
};

export const updateEstateUnitStatus = async (
  id: string,
  status: EstateUnitStatusEnum,
  unlinkUsers?: boolean
): Promise<EstateUnit> => {
  return patch(`/estate-units/${id}/status`, {
    status,
    ...(unlinkUsers !== undefined ? { unlinkUsers } : {})
  });
};
